import LoginClient from '../layouts/LoginClient.vue';
import LoginGrp from '../layouts/LoginGrp.vue';
import RejectNoticeOfPrivacy from '../views/RejectNoticeOfPrivacy.vue';
import Home from '../views/HomeClient.vue';
import ConditionsComponent from '../components/ConditionsComponent.vue';
import ChecklistMobile from '../views/budgets/ChecklistMobile.vue';
import InventoryMobile from '../views/budgets/InventoryMobile.vue';
import ReceptionMobile from '../views/reception/ReceptionMobile.vue';
import TechnicalReportMobile from '../views/reports/TechnicalReportMobile.vue';
import InvoicesMobile from '../views/invoices/InvoicesMobile.vue';
import PaymentOrderMobile from '../views/payments/PaymentOrderMobile.vue';
import ShowPdf from '../views/invoices/ShowPdf.vue';
import Notifications from '../views/notifications/NotificationsView.vue';
import SendMessage from '../views/notifications/SendMessage.vue';
import CONST from '../const';
import { validateAccess } from '../libs/helpers';

import InitView from '../views/InitView.vue';
import LogOutView from '../views/LogOutView.vue';
import AuthView from '../views/AuthView.vue';

const accessValidate = (module, next) => {
  if (validateAccess(module)) next();
  else next({ name: 'home' });
};

export default [
  { path: '/', name: 'Init', component: InitView },
  { path: '/logout', name: 'logout', component: LogOutView },
  { path: '/order', name: 'loginClient', component: LoginClient },
  { path: '/login_grp', name: 'loginGrp', component: LoginGrp },
  { path: '/auth', name: 'auth', component: AuthView },
  { path: '/reject_notice_of_privacy', name: 'reject_notice_of_privacy', component: RejectNoticeOfPrivacy },
  { path: '/home', name: 'home', component: Home },
  { path: '/conditions', name: 'conditions', component: ConditionsComponent },
  {
    path: '/inventario',
    name: 'inventario',
    component: InventoryMobile,
    props: (route) => ({
      ...route.params,
    }),
    beforeEnter: (to, from, next) => accessValidate(CONST.MODULE_ACTIVITIES, next),
  },
  {
    path: '/checklist',
    name: 'checklist',
    component: ChecklistMobile,
    props: (route) => ({
      ...route.params,
    }),
    beforeEnter: (to, from, next) => accessValidate(CONST.MODULE_ACTIVITIES, next),
  },
  {
    path: '/report/:id',
    name: 'report',
    component: TechnicalReportMobile,
    props: (route) => ({
      ...route.params,
    }),
  },
  {
    path: '/detail/:id',
    name: 'detail',
    component: TechnicalReportMobile,
    props: (route) => ({
      ...route.params,
    }),
    beforeEnter: (to, from, next) => accessValidate(CONST.MODULE_ACTIVITIES, next),
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: InvoicesMobile,
    beforeEnter: (to, from, next) => accessValidate(CONST.MODULE_INVOICES, next),
  },
  {
    path: '/invoices/show_pdf/:orderIdDms',
    name: 'showPdf',
    component: ShowPdf,
    beforeEnter: (to, from, next) => accessValidate(CONST.MODULE_INVOICES, next),
  },
  {
    path: '/payment_order',
    name: 'payment_order',
    component: PaymentOrderMobile,
  },
  {
    path: '/reception',
    name: 'reception',
    component: ReceptionMobile,
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: Notifications,
  },
  {
    path: '/send_message',
    name: 'send_message',
    component: SendMessage,
  },
  { path: '*', redirect: { name: 'home' } },
];
